import React from 'react';
import {useTranslation} from "react-i18next";
import EmptyState from "../../../feeback/State/Empty";
import Graphic from "../../../../../resources/images/surveyReport.svg";

const EmptyReport = () => {
    const {t} = useTranslation();

    return (
        <EmptyState
            title={t('survey_empty_report')}
            textI18Key='survey_empty_report_text'
            graphic={Graphic}
        />
    );
};

export default EmptyReport;